'use strict';

var ServiceModalCtrlNew = function(
  $scope,
  service,
  subscription,
  office,
  objects,
  tariffServices,
  Notification,
  gettextCatalog,
  OfficeModel,
  DatepickerSettings,
  modalInstance,
) {
  $scope.currentService = service;
  $scope.backupGroups = {};
  $scope.office = null;
  $scope.groups = [];
  $scope.pickedGroup = '';
  $scope.objects = [];
  $scope.needPremium = false;
  $scope.isPricePerUnit = false;
  $scope.isSecondTimeWeekly = false;
  $scope.colors = [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFEB3B',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B',
    '#999999',
    '#000000',
  ];
  $scope.unitFactors = [];
  $scope.tariffServices = tariffServices;
  $scope.office = office;
  $scope.objects = objects;
  $scope.currentTariffService = null;
  var serviceMoved = false;
  var initWatchFired = false;
  var DEFAULT_TAX = 0;

  $scope.filter = {
    start: moment()
      .subtract(6, 'month')
      .toDate(),
    end: new Date(),
  };
  $scope.dtpOptionsDateRangeStart = angular.copy(DatepickerSettings.default);
  $scope.dtpOptionsDateRangeEnd = angular.copy(DatepickerSettings.default);
  $scope.showPremiumNotification = subscription.onlyBasicFunctions;
  $scope.taxes = [
    {
      label: '0.0 %',
      value: 0,
    },
    {
      label: '2.5 %',
      value: 2.5,
    },
    {
      label: '7.7 %',
      value: 7.7,
    },
    {
      label: '8.1 %',
      value: 8.1,
    }
  ];

  function init() {
    var count = 0;

    if ($scope.office.tariff590Allowed) {
      for (var i = 1; i <= 24; i++) {
        $scope.unitFactors.push({
          label: i.toString(),
          value: i,
        });
      }
    }

    if ($scope.office.serviceGroups instanceof Array) {
      for (var i = 0, groups = $scope.office.serviceGroups.length; i < groups; i++) {
        $scope.groups.push($scope.office.serviceGroups[i].name);

        count += $scope.office.serviceGroups[i].services.length;
      }
    }

    // new service
    if (!service) {
      service = {
        price: '',
        duration: 30,
        preparation: 0,
        followup: 0,
        color: 'default',
        resources: {
          employee: [],
          room: [],
          other: [],
        },
      };

      // get objects for service:employee matching
      for (var i = 0, resLen = $scope.objects.length; i < resLen; i++) {
        var resource = $scope.objects[i];

        service.resources[resource.type].push(resource._id);
      }

      $scope.office.serviceGroups[0].services.push(service);
      $scope.pickedGroup = $scope.office.serviceGroups[0].name;
    } else {
      var index = -1;
      // find old group and delete service
      for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
        index = _.findIndex($scope.office.serviceGroups[i].services, { _id: service._id });

        if (index > -1) {
          $scope.pickedGroup = $scope.office.serviceGroups[i].name;

          break;
        }
      }
    }

    service.timeOffer = service.timeOffer || { mode: 'disabled' };

    if (service.timeOffer.start) {
      service.timeOffer.start = new Date(service.timeOffer.start);
    }

    if (service.timeOffer.end) {
      service.timeOffer.end = new Date(service.timeOffer.end);
    }

    service.accounting = service.accounting || {};

    if (!service.accounting.tax && service.accounting.tax !== 0) {
      service.accounting.tax = DEFAULT_TAX;
    }

    if ($scope.office.tariff590Allowed) {
      if (service.accounting.posNum) {
        $scope.currentTariffService = _.find($scope.tariffServices, {
          posNum: service.accounting.posNum,
        });

        if (
          $scope.currentTariffService &&
          $scope.currentTariffService.description !== 'pro 5 Minuten'
        ) {
          $scope.isPricePerUnit = true;
        }
      }
    }

    service.color = service.color || 'default';
    service.preparation = service.preparation || 0;
    service.followup = service.followup || 0;
    $scope.currentService = service;
    $scope.backupGroups = angular.copy($scope.office.serviceGroups);
  }

  /**
   * reset the data made in appointment form if push abort button
   */
  $scope.abort = function() {
    for (var prob in $scope.backupGroups) {
      if ($scope.office.serviceGroups.hasOwnProperty(prob)) {
        $scope.office.serviceGroups[prob] = $scope.backupGroups[prob];
      }
    }

    $scope.close();
  };

  /**
   * move service to selected group
   */
  $scope.$watch('pickedGroup', function(newValue, oldValue) {
    if (newValue !== oldValue) {
      serviceMoved = true;
      moveService();
    }
  });

  /**
   * save current appointment to database
   */
  $scope.save = function() {
    var groupIndex = -1;
    var serviceIndex = -1;
    $scope.showValidation = true;

    if ($scope.currentService.price === '') {
      delete $scope.currentService.price;
    }

    if ($scope.currentService.color === 'default') {
      delete $scope.currentService.color;
    }

    if (shorthandExists()) {
      Notification.addErrorMessage(gettextCatalog.getString('shorthand already used'));
    } else if ($scope.serviceForm.$valid) {
      // replace existing service
      if ($scope.currentService._id) {
        for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
          groupIndex = i;
          serviceIndex = _.findIndex($scope.office.serviceGroups[i].services, {
            _id: $scope.currentService._id,
          });

          if (serviceIndex > -1) {
            break;
          }
        }

        $scope.office.serviceGroups[groupIndex].services[serviceIndex] = $scope.currentService;
      }

      OfficeModel.update($scope.office, function(error) {
        if (error) {
          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
        } else {
          $scope.showValidation = false;
          Notification.addSuccessMessage(
            gettextCatalog.getString('Service "{{name}}" saved', {
              name: $scope.currentService.name,
            }),
          );
          $scope.close();
        }
      });
    }
  };

  /**
   * delete current appointment
   */
  $scope.delete = function() {
    var index = -1;
    // find old group and delete service
    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
      index = _.findIndex($scope.office.serviceGroups[i].services, {
        _id: $scope.currentService._id,
      });

      for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
        if ($scope.office.serviceGroups[i].services[j]._id === $scope.currentService._id) {
          index = j;
          break;
        }
      }

      if (index > -1) {
        $scope.office.serviceGroups[i].services.splice(index, 1);
        break;
      }
    }

    if (index > -1) {
      OfficeModel.update($scope.office, function(error) {
        if (error) {
          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
        } else {
          Notification.addSuccessMessage(
            gettextCatalog.getString('Service "{{name}}" deleted', {
              name: $scope.currentService.name,
            }),
          );
          $scope.close();
        }
      });
    } else {
      Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
    }
  };

  $scope.getNumber = function(num) {
    return new Array(num);
  };

  $scope.addWeeklyTime = function(index) {
    var firstEndTime = $scope.currentService.timeOffer.weekPlan[index].times[0].end;

    $scope.currentService.timeOffer.weekPlan[index].times.push({
      start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
      end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240,
    });

    $scope.isSecondTimeWeekly = true;
  };

  $scope.removeWeeklyTime = function(index) {
    $scope.currentService.timeOffer.weekPlan[index].times.splice(1, 1);
    $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
  };

  $scope.currentTariffChanged = function(item) {
    var factor = 1;
    $scope.currentService.accounting = $scope.currentService.accounting || {};
    $scope.currentService.accounting.posNum = item.posNum;
    $scope.currentService.accounting.posText = item.posText;
    $scope.currentService.accounting.description = item.description;

    if (
      $scope.currentService.accounting.description === 'pro 5 Minuten' ||
      $scope.currentService.accounting.posText.indexOf('pro 5 Minuten') > -1
    ) {
      $scope.currentService.accounting.tariffDuration = 5;
      $scope.isPricePerUnit = false;
      factor = $scope.currentService.duration / $scope.currentService.accounting.tariffDuration;
      $scope.pricePerUnit = $scope.currentService.price / factor;
    } else {
      $scope.currentService.accounting.tariffDuration = $scope.currentService.duration;
      $scope.isPricePerUnit = true;

      $scope.pricePerUnit = $scope.currentService.price;
    }
  };

  /**
   * move the service to chosen service group
   */
  function moveService() {
    var index = -1;
    // find old group and delete service
    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
      index = _.findIndex($scope.office.serviceGroups[i].services, {
        _id: $scope.currentService._id,
      });

      if (index > -1) {
        $scope.office.serviceGroups[i].services.splice(index, 1);
        break;
      }
    }

    // move to new group
    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
      if ($scope.office.serviceGroups[i].name === $scope.pickedGroup) {
        $scope.office.serviceGroups[i].services.push($scope.currentService);
      }
    }
  }

  /**
   * check if a shorthand already is taken
   * @returns {boolean}
   */
  function shorthandExists() {
    var count = 0;
    if ($scope.currentService.shorthand) {
      for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
        for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
          if (
            $scope.office.serviceGroups[i].services[j].shorthand === $scope.currentService.shorthand
          ) {
            count++;
          }
        }
      }
    }

    if (count < 2) {
      return false;
    } else {
      return true;
    }
  }

  function setMinMaxDate() {
    $scope.dtpOptionsDateRangeStart.maxDate =
      $scope.currentService.timeOffer.end ||
      moment()
        .add(1, 'month')
        .toDate();
    $scope.dtpOptionsDateRangeEnd.minDate = $scope.currentService.timeOffer.start || new Date();
  }

  function checkSecondTimeWeekly() {
    var secondTimeIndex = _.findIndex(
      _.get($scope, 'currentService.timeOffer.weekPlan', []),
      function(day) {
        return day.times.length > 1;
      },
    );

    return secondTimeIndex > -1 ? true : false;
  }

  $scope.$watch('currentService.price', function(newValue) {
    var price = _.toNumber(newValue);
    var duration = _.toNumber($scope.currentService.duration);
    var factor = 1;

    if (duration) {
      factor = duration / 5;
    }

    if (price) {
      $scope.pricePerUnit = price / factor;
    }

    if ($scope.isPricePerUnit) {
      $scope.pricePerUnit = newValue;
    } else {
      $scope.pricePerUnit = parseFloat($scope.pricePerUnit) || 0;
      $scope.pricePerUnit = $scope.pricePerUnit.toFixed(2);
    }
  });

  $scope.$watch(
    'currentService.timeOffer',
    function(newValue) {
      switch (newValue.mode) {
        case 'disabled':
          delete $scope.currentService.timeOffer.weekPlan;
          delete $scope.currentService.timeOffer.start;
          delete $scope.currentService.timeOffer.end;
          break;
        case 'dateRange':
          if (
            !$scope.currentService.timeOffer.start ||
            !moment($scope.currentService.timeOffer.start).isValid()
          ) {
            $scope.currentService.timeOffer.start = moment()
              .startOf('day')
              .toDate();
          }

          if (
            !$scope.currentService.timeOffer.end ||
            !moment($scope.currentService.timeOffer.end).isValid()
          ) {
            $scope.currentService.timeOffer.end = moment()
              .add(1, 'month')
              .endOf('day')
              .toDate();
          }

          delete $scope.currentService.timeOffer.weekPlan;
          break;
        case 'time':
          if (!_.isArray($scope.currentService.timeOffer.weekPlan)) {
            $scope.currentService.timeOffer.weekPlan = [];

            for (var i = 0; i < 7; i++) {
              $scope.currentService.timeOffer.weekPlan.push({
                available: false,
                times: [],
              });
            }

            _.forEach($scope.office.openingHours.regular, function(openingHour, index) {
              var day = $scope.currentService.timeOffer.weekPlan[index];
              day.available = openingHour.open;
              day.times = openingHour.times;
            });
          }

          delete $scope.currentService.timeOffer.start;
          delete $scope.currentService.timeOffer.end;
          break;
      }

      if (newValue.mode === 'time') {
        $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
      }

      setMinMaxDate();
      initWatchFired = true;
    },
    true,
  );

  $scope.close = function() {
    modalInstance.close();
  };

  init();
};

module.exports = ServiceModalCtrlNew;



// WEBPACK FOOTER //
// ./src/app/modules/service/modal/ServiceModalCtrlNew.js